import * as React from "react";
import { ColumnProps } from './CellColumnProps';
import moment from "moment";

interface Props extends ColumnProps
{
    getValue: (item: any) => any;
}

// This column displays raw text
export class DataGridTextColumn extends React.Component<Props, null>
{
    render()
    {
        const { datum, getValue, cellClassName } = this.props;
        const LastDataDateTimeReceivedOn = datum.LastDataDateTimeReceivedOn ? moment(datum.LastDataDateTimeReceivedOn).format('YYYY-MM-DD HH:mm') : null;
        return (
          <td className={cellClassName}>
            {
              LastDataDateTimeReceivedOn &&
              <span className="tooltip-message" data-toggle="tooltip" data-placement="top" title={`Received At: ${LastDataDateTimeReceivedOn}`}>
                { getValue(datum) }
              </span>
            }
            { !LastDataDateTimeReceivedOn && getValue(datum) }
          </td>
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/DataGrid/DataGridTextColumn.tsx